export var FieldType;
(function (FieldType) {
    FieldType["Date"] = "date";
    FieldType["Money"] = "money";
    FieldType["Ref"] = "ref";
    FieldType["Number"] = "number";
    FieldType["List"] = "list";
    FieldType["Text"] = "text";
})(FieldType || (FieldType = {}));
